import { Questionnaire } from '../Questionnaires/types';
import { QuestionnaireOption } from './interface';

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function getSelectedOption(
  questionnaires: Questionnaire[],
  selectedQuestionnaireId?: string,
  selectedQuestionnaire?: Questionnaire | null
) {
  if (selectedQuestionnaireId === null) return null;

  if (selectedQuestionnaireId) {
    const selectedQuestionnaireById = findSelectedQuestionnaireById(questionnaires, selectedQuestionnaireId);

    if (selectedQuestionnaireById) {
      return createQuestionnaireOption(selectedQuestionnaireById);
    }
  }

  if (selectedQuestionnaire) {
    return createQuestionnaireOption(selectedQuestionnaire);
  }
}

function findSelectedQuestionnaireById(questionnaires: Questionnaire[], selectedQuestionnaireId: string) {
  return questionnaires.find(questionnaire => questionnaire._id === selectedQuestionnaireId);
}

export function createOptions(questionnaires: Questionnaire[], selectedQuestionnaire?: Questionnaire | null) {
  const options: QuestionnaireOption[] = [createEmptyOption()];

  if (selectedQuestionnaire) {
    options.push(createQuestionnaireOption(selectedQuestionnaire));
  }

  return options.concat(mapQuestionnairesToOptions(questionnaires));
}

function mapQuestionnairesToOptions(questionnaires: Questionnaire[]): QuestionnaireOption[] {
  return questionnaires.map(createQuestionnaireOption);
}

function createQuestionnaireOption(questionnaire: Questionnaire): QuestionnaireOption {
  return {
    value: questionnaire._id,
    label: questionnaire.title
  };
}

function createEmptyOption(): QuestionnaireOption {
  return {
    value: null,
    label: 'None'
  };
}
